import { ValidateJSModel } from 'forms/shared/types';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ForeignBusinessSubsequentContactsItemModel } from '../types';

const foreignBusinessSubsequentContactsItemValidator: ValidateJSModel<ForeignBusinessSubsequentContactsItemModel> = {
  Subsequent: { hasValue: true },

  Recent: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { earliest: options.applicantBirthdate, latest: DEFAULT_LATEST },
  }),

  Future: { hasValue: true },
};

export default foreignBusinessSubsequentContactsItemValidator;
